import { trpc } from 'src/utils/trpc';
import WindowStickerWeb from './WindowStickerWeb';
import VehicleCertificateWeb from './VehicleCertificateWeb';
import VehicleDetailsWeb from './VehicleDetailsWeb';
import VehicleConditionReportWeb from './VehicleConditionReportWeb';
import Transportation from 'src/@carketa/sales-packet/components/Transportation';

type VehicleSalesPacketProps = {
  vin?: string;
  inspectionId?: string;
  pdfMode?: boolean;
  hasSalesPacket?: boolean;
};

export const VehicleSalesPacket = ({
  vin,
  pdfMode,
}: VehicleSalesPacketProps) => {
  const { data: window_sticker } = trpc.window_sticker.getNeoVin.useQuery(
    {
      vin: vin ?? '',
    },
    {
      placeholderData: (previousData: any) => previousData,
      refetchOnWindowFocus: false,
    }
  );
  return <WindowStickerWeb neoVin={window_sticker} pdfMode={pdfMode} />;
};

export const VehicleCertificate = ({
  vin,
  pdfMode,
}: VehicleSalesPacketProps) => {
  const { data: vehicle } = trpc.vehicles.getByStickerOrId.useQuery(
    {
      vin: vin ?? '',
    },
    {
      placeholderData: (previousData) => previousData,
      refetchOnWindowFocus: false,
    }
  );

  const { data: vehicle_inspections } =
    trpc.vehicle_inspection.getAllConditionReportByVehicleId.useQuery(
      { vehicle_id: vehicle ? vehicle.id : '' },
      {
        refetchOnWindowFocus: false,
        placeholderData: (previousData) => previousData,
      }
    );
  return (
    <VehicleCertificateWeb
      vehicle={vehicle}
      vehicle_inspections={vehicle_inspections}
      pdfMode={pdfMode}
    />
  );
};

export const VehicleDetails = ({ vin, pdfMode }: VehicleSalesPacketProps) => {
  const { data: vehicle } = trpc.vehicles.getByStickerOrId.useQuery(
    {
      vin: vin ?? '',
    },
    {
      placeholderData: (previousData) => previousData,
      refetchOnWindowFocus: false,
    }
  );

  if (!vehicle) {
    return <></>;
  }
  return <VehicleDetailsWeb vehicle={vehicle} pdfMode={pdfMode} />;
};

export const VehicleInspection = ({
  vin,
  inspectionId,
  pdfMode,
  hasSalesPacket,
}: VehicleSalesPacketProps) => {
  const { data: vehicle } = trpc.vehicles.getByStickerOrId.useQuery(
    {
      vin: vin ?? '',
    },
    {
      placeholderData: (previousData) => previousData,
      refetchOnWindowFocus: false,
    }
  );

  const { data: vehicle_inspections } =
    trpc.vehicle_inspection.getAllConditionReportByVehicleId.useQuery(
      { vehicle_id: vehicle ? vehicle.id : '' },
      {
        refetchOnWindowFocus: false,
        placeholderData: (previousData) => previousData,
        enabled: !!vehicle,
      }
    );

const filtered_vehicle_inspections = vehicle_inspections?.filter((inspection) => {
  if(hasSalesPacket && inspection?.inspection_template?.use_condition_report) {
    return true;
  }
  else return !!(!hasSalesPacket && inspection?.inspection_template?.use_condition_report);
  });

  return (
    <VehicleConditionReportWeb
      vehicle={vehicle}
      vehicle_inspections={filtered_vehicle_inspections}
      inspectionId={inspectionId ?? null}
      pdfMode={pdfMode}
    />
  );
};

export const VehicleTransportationDetails = ({ pdfMode, vin }: { pdfMode: boolean; vin: string }) => {
  return <Transportation pdfMode={pdfMode} vin={vin ?? ''} />;
};
